import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-languages',
  templateUrl: './languages.component.html',
  styleUrls: ['./languages.component.scss']
})
export class LanguagesComponent implements OnInit {
  names: any;
  queryString: string;

  languages = [
    {
      src: 'gb',
      name: 'United Kingdom',
      language: 'English'
    },
    {
      src: 'ba',
      name: 'Bosnia Herzegovina',
      language: 'Bosnian',
    },
    {
      src: 'bg',
      name: 'Bulgaria',
      language: 'Bulgarian'
    },
    {
      src: 'hr',
      name: 'Crotia',
      language: 'Hrvatski',
    },
    {
      src: 'cz',
      name: 'Czech',
      language: 'Czech'
    },
    {
      src: 'dk',
      name: 'Denmark',
      language: 'Dansk',
    },
    {
      src: 'fi',
      name: 'Finland',
      language: 'Finnish'
    },
    {
      src: 'fr',
      name: 'France',
      language: 'French',
    },
    {
      src: 'hu',
      name: 'Hungary',
      language: 'Hungary',
    },
    {
      src: 'de',
      name: 'Germany',
      language: 'German',
    },
    {
      src: 'it',
      name: 'Italy',
      language: 'Italian',
    }
  ];

  constructor() { }


  ngOnInit() {
  }

}
